/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  EventNotificationData,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface GetAzzurroEventsConfigurationByPlantIdInput {
  plantId: string;
}
const build = (_query: DocumentNode, input: GetAzzurroEventsConfigurationByPlantIdInput, name = 'QueryResult') => {
  const bQuery = `
  query ${ name }(`+
    ( input.plantId !== undefined ? `$plantId: String = ${JSON.stringify(input.plantId).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    getAzzurroEventsConfigurationByPlantId(
      ${ input.plantId !== undefined ? 'plantId: $plantId,' : '' }
    ){
      ...eventnotificationdata
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class GetAzzurroEventsConfigurationByPlantIdQuery {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment eventnotificationdata on EventNotificationData { ... }
   */
  async execute(_query: DocumentNode, input: GetAzzurroEventsConfigurationByPlantIdInput, refresh = false) {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    const fetchPolicy = refresh ? 'network-only' : 'cache-first';
   return await client?.query<{ getAzzurroEventsConfigurationByPlantId: Partial<EventNotificationData> }>({ query: build(_query, input), fetchPolicy });
  }
}
